<template>
  <div
    id="modalLogin"
    class="proModalLogin modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLogin"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="pull-right">
            <button
              class="btn"
              data-dismiss="modal"
              aria-label="Close"
              @click="close()"
            >
              <span><pb-icon class="fas fa-times" /></span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="html" class="text-center">
            <div id="embed-modal" :class="{ 'embed-responsive embed-responsive-16by9': isResponsiveEmbed }" v-html="html" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalLogin',
  data() {
    return {
      portal: this.$portal,
      user: this.$user,
      company: this.$company,

      html: '',
    };
  },
  computed: {
    isResponsiveEmbed() {
      if (_.get(this.company, 'json.modalLogin.responsive') !== true && _.get(this.company, 'json.modalLogin.responsive') !== 'true') return false;
      $('.modal-dialog').css({ width: '75%', height: '75%' });
      return true;
    },
  },
  mounted() {
    this.getContent();
    this.hideMobile();

    $('.proModalLogin').on('hidden.bs.modal', () => {
      this.close();
    });
  },
  methods: {
    close() {
      $('.proModalLogin').modal('hide');
      this.html = '';
      $('input[name="email"]').focus();
    },
    getContent() {
      if (_.has(this.company, 'json.modalLogin.html')) {
        const content = this.$cookies.get('watched');
        if (!content || this.company.json.modalLogin.html != content)
          this.html = this.company.json.modalLogin.html;
      }
    },
    hideMobile() {
      $(window).resize(() => {
        if ($(window).width() <= '768') this.close();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  .modal-content {
    background-color: transparent;
    border: none;
    box-shadow: none;
    height: 100%;
    width: 100%;
  }
  .modal-body {
    padding: 0px 0px 0px 0px;
    height: 100%;
    width: 100%;
  }
  button {
    opacity: 0.75;
  }
  button:hover {
    opacity: 1;
  }
  .modal-header {
    border: 0 !important;
    padding: 15px 0 15px 0 !important;
  }
}
</style>
